<template>
  <div class="search search-home" v-show="dataReady">
    <InputBox @click="toggle('destination')" class="search__input-box" :label="selectedDestinationLabel" :value="selectedDestinationValue" icon="map" />
    <InputBox @click="toggle('airport')" class="search__input-box" :label="selectedAirportLabel" :value="selectedAirportValue" icon="v" />
    <InputBox @click="toggle('dates')" class="search__input-box" label="Wylot od - Przylot do" :value="selectedDatesValue" icon="calendar" />
    <InputBox @click="toggle('duration')" class="search__input-box" label="Długość pobytu" :value="selectedDurationValue" icon="v" />
    <InputBox @click="toggle('people')" class="search__input-box" label="" :value="selectedPeopleValue" icon="v" />

    <transition name="slide-left-with-fade">
      <Destination v-if="popups.destination"
        v-model="destinations"
        @input="toggle('destination')"
        @close="toggle('destination')"
      />
      <Airport v-if="popups.airport"
        v-model="airports"
        @input="toggle('airport')"
        @close="toggle('airport')"
      />
      <MobileCalendar v-if="popups.dates" @close="toggle('dates')"
        :selectedDates="selectedDates"
        :validDates="validDates"
        @selectFrom="selectDateFrom" @selectTo="selectDateTo"
      />
      <Duration v-if="popups.duration"
        v-model="durations"
        @input="toggle('duration')"
        @close="toggle('duration')"
      />
      <People v-if="popups.people"
        v-model="people"
        @input="toggle('people')"
        @close="toggle('people')" />
    </transition>

    <button class="search__submit" role="button" @click="search">
      Szukaj
      <Icon icon="v" />
    </button>

    <div class="search__advertisment">{{ advertisment }}</div>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

import Airport from './fields/AirportPopup'
import Destination from './fields/DestinationPopup'
import People from './fields/PeoplePopup'
import InputBox from './InputBox.vue'
import AdvertismentLogic from './logic/Advertisment'
import AirportLogic from './logic/Airport'
import DatesLogic from './logic/Dates'
import DestinationLogic from './logic/Destination'
import PeopleLogic from './logic/People'
import DurationLogic from './logic/Duration'
import Duration from './fields/DurationPopup.vue'

import DataReadyMixin from '@/components/DataReadyMixin'
import Icon from '@/components/Icon.vue'
import MobileCalendar from '@/components/MobileCalendar.vue'
import PopupHandler from '@/components/search/PopupHandler'
import { API, SearchConstraintsRequest } from '@/modules/api'

@Component({
  mixins: [
    PopupHandler,
    DataReadyMixin,
    DestinationLogic,
    AirportLogic,
    DatesLogic,
    PeopleLogic,
    DurationLogic,
    AdvertismentLogic,
  ],
  components: {
    InputBox,
    Icon,
    Destination,
    Airport,
    MobileCalendar,
    People,
    Duration,
  },
  props: {
    form: {
      type: HTMLFormElement,
      required: true,
    },
  },
})
export default class MobileHome extends Vue {
  advertisment = 'Some advertisment info here'

  created () {
    new API()
      .getSearchConstraints(new SearchConstraintsRequest())
      .then(this.readSearchConstraintsResponse)
      .then(this.markDataAsReady)
  }

  search () {
    this.saveValuesToForm()
    this.form.submitWFFM()
  }

  saveValuesToForm () {
    this.dx.destination.data = this.destinations
    this.dx.airport.data = this.airports
    this.dx.dates.data = this.selectedDates
    this.dx.duration.data = this.durations
    this.dx.people.data = this.people
  }

  updateAvailableValues () {
    this.saveValuesToForm()
    new API()
      .getSearchConstraints(SearchConstraintsRequest.fromWFFMForm(this.form))
      .then(this.updateSearchConstraintsResponse)
  }

  /**
   * @argument {SearchConstraintsResponse} response
   */
  readSearchConstraintsResponse (response) {
    const inThreeWeeks = moment(response.minDate).add({ days: 21 })
    this.selectedDates = moment.range(response.minDate, moment.min(response.maxDate, inThreeWeeks))
    this.validDates = moment.range(response.minDate, response.maxDate)
    this.markAvailabilityOfListEntries(this.airports, response.airports)
    this.markAvailabilityOfListEntries(this.destinations, response.destinations)
    this.airports = this.airports.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.destinations = this.destinations.sort((d1, d2) => d1.name.localeCompare(d2.name))
    this.markAvailabilityOfRadioElements(this.durations.ranges, response.validRanges)
  }

  /**
   * @argument {SearchConstraintsResponse} response
   */
  updateSearchConstraintsResponse (response) {
    this.selectedDates = moment.range(moment.max(this.selectedDates.start, response.minDate), moment.min(this.selectedDates.end, response.maxDate))
    this.validDates = moment.range(response.minDate, response.maxDate)
    this.markAvailabilityOfListEntries(this.airports, response.airports)
    this.markAvailabilityOfListEntries(this.destinations, response.destinations)
    this.airports = this.airports.sort((a1, a2) => a1.name.localeCompare(a2.name))
    this.destinations = this.destinations.sort((d1, d2) => d1.name.localeCompare(d2.name))
    this.markAvailabilityOfRadioElements(this.durations.ranges, response.validRanges)
  }

  markAvailabilityOfListEntries (list, ids) {
    list.forEach(item => {
      item.enabled = ids.some(x => item.value.indexOf(x) !== -1)
      if (!item.enabled) item.selected = false
    })
  }

  markAvailabilityOfRadioElements (list, ids) {
    list.forEach(item => {
      item.enabled = ids.some(x => x === item.value)
    })
  }
}
</script>

<style lang="scss">
@import '../../stylesheets/animations.scss';
</style>

<style lang="scss" scoped>
.search {
  display: grid;

  background-color: #005ca9;
  color: white;
  padding: 23px 20px 0 20px;

  &__input-box {
    margin-bottom: 10px;
  }

  &__submit {
    width: 100%;
    background-color: transparent;
    border: 2px solid #fff;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 12px;
    font-family: 'Gotham';
    margin: 20px auto;
    padding: 7px;

    .figure {
      font-size: 6px;
      transform: rotate(-90deg);
      display: inline-block;
      vertical-align: top;
      padding-right: 10px;
    }
  }

  &__advertisment {
    text-align: center;
    font-family: Georgia;
    font-size: 13px;
    font-style: italic;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 15px 15px 15px;
  }
}
</style>

<style lang="scss">
// Completely hide server-generated content.
// It requires max-width media query because the rest of CSSes on the page are like that.
@media screen and (max-width: 767px) {
  .page--home section#stage .main-search {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/MobileHome.vue